/* ============================================================
   FRAISE NOIRE — Recherche instantanée (overlay)
   Client-side sur window.FN_PRODUCTS (83 pièces) : zéro réseau,
   résultats immédiats. Ouverte via window.FN_SEARCH.open()
   (branchée sur [data-search] par home.js) ou le raccourci « / ».
   ============================================================ */
(() => {
  /* Echappement — voir js/home.js. Les titres du catalogue contiennent des
     guillemets droits qui, non echappes, ferment l'attribut qui les porte. */
  const ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  const esc = v => String(v == null ? '' : v).replace(/[&<>"']/g, c => ESCAPES[c]);

  'use strict';
  const P = window.FN_PRODUCTS || [];
  if (!P.length) return;
  const eur = n => n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  const norm = s => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

  let overlay = null, input = null, list = null, lastFocus = null, debounce = 0;

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'fsearch';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-label', 'Recherche');
    overlay.hidden = true;
    overlay.innerHTML = `
      <div class="fsearch__panel">
        <div class="fsearch__bar">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.2-3.2"/></svg>
          <input type="search" placeholder="Casquette, hoodie, ensemble…" aria-label="Rechercher un produit" autocomplete="off">
          <button class="fsearch__close" aria-label="Fermer">Fermer</button>
        </div>
        <div class="fsearch__hint label">${P.length} pièces · tape pour chercher</div>
        <div class="fsearch__list" role="listbox"></div>
      </div>`;
    document.body.appendChild(overlay);
    input = overlay.querySelector('input');
    list = overlay.querySelector('.fsearch__list');
    overlay.addEventListener('click', e => { if (e.target === overlay || e.target.closest('.fsearch__close')) close(); });
    input.addEventListener('input', () => { clearTimeout(debounce); debounce = setTimeout(() => render(input.value), 120); });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !overlay.hidden) close();
      if (e.key === '/' && overlay.hidden && !/INPUT|TEXTAREA/.test(document.activeElement.tagName)) { e.preventDefault(); open(); }
    });
  }

  function row(p) {
    return `<a class="fsearch__item" href="${p.url || "/products/" + p.handle}" role="option">
      ${(window.FN && window.FN.media) ? window.FN.media(p.img, 'alt="" loading="lazy"', '56px') : `<img src="${esc(p.img)}" alt="" loading="lazy">`}
      <span class="fsearch__name">${esc(p.title)}<small>${esc(p.cat)}</small></span>
      <b class="tabular">${eur(p.price)}</b>
    </a>`;
  }

  let minuteurRecherche;
  function render(q) {
    const n = norm(q).trim();
    if (!n) {
      // suggestions par défaut : 6 premières pièces (têtes de catégories)
      list.innerHTML = `<p class="fsearch__label label">Les icônes</p>` + P.slice(0, 6).map(row).join('');
      return;
    }
    const words = n.split(/\s+/);
    const res = P.filter(p => { const hay = norm(p.title + ' ' + p.cat); return words.every(w => hay.includes(w)); });
    /* UNE RECHERCHE, PAS UNE FRAPPE.
       L'evenement partait a chaque caractere, 120 ms apres : taper « hoodie »
       remontait « h », « ho », « hoo »… Le rapport de recherche devenait un
       rapport de prefixes, inexploitable pour savoir ce que les clients
       cherchent vraiment. On n'annonce donc qu'une requete stabilisee : au
       moins trois caracteres, et plus d'une seconde sans frappe. */
    clearTimeout(minuteurRecherche);
    if (n.length >= 3) minuteurRecherche = setTimeout(() => {
      const T = window.FN_TRACK;
      /* `custom()` ne pousse QUE vers le dataLayer : Meta et TikTok ne
         recevaient aucun signal Search, alors que l'API dediee existait et
         n'etait appelee nulle part. On emet les deux : l'evenement standard
         pour les plateformes, le custom pour le detail interne. */
      T && T.search && T.search(q.trim());
      T && T.custom && T.custom('search_results', { search_term: q.trim(), results: res.length });
    }, 1000);
    list.innerHTML = res.length
      ? `<p class="fsearch__label label">${res.length} résultat${res.length > 1 ? 's' : ''}</p>` + res.slice(0, 24).map(row).join('')
      : `<p class="fsearch__empty">Aucune pièce pour « ${esc(q)} ».<br><a href="/collections/all">Voir toute la boutique →</a></p>`;
  }

  function open() {
    if (!overlay) build();
    lastFocus = document.activeElement;
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('show'));
    document.body.classList.add('search-open');
    render('');
    input.value = '';
    input.focus();
  }
  function close() {
    overlay.classList.remove('show');
    document.body.classList.remove('search-open');
    setTimeout(() => { overlay.hidden = true; }, 220);
    lastFocus && lastFocus.focus && lastFocus.focus();
  }

  window.FN_SEARCH = { open, close };
})();
